module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    key: _vm.key,
    ref: "commonCostModal",
    on: {
      "input": _vm.closeInput
    }
  }, [_vm._t("default", [_c('a', {
    staticClass: "fa-stack fa-lg"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })])], {
    "slot": "trigger"
  }), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Reason"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reason),
      expression: "body.reason"
    }],
    domProps: {
      "value": (_vm.body.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "reason", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Type"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.common_cost_type_id),
      expression: "body.common_cost_type_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "common_cost_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.commonCostTypes), function(costType) {
    return _c('option', {
      domProps: {
        "value": costType.id
      }
    }, [_vm._v(_vm._s(costType.name))])
  }), 0)])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Tax"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.tax),
      expression: "body.tax"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "tax", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vats), function(vat) {
    return _c('option', {
      domProps: {
        "value": vat.percentage / 100
      }
    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
  }), 0)]), _c('label', [_vm._v("Add as a debit amount?")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDebit),
      expression: "isDebit"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.isChecked,
      "checked": Array.isArray(_vm.isDebit) ? _vm._i(_vm.isDebit, _vm.isChecked) > -1 : (_vm.isDebit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDebit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.isChecked,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isDebit = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isDebit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDebit = $$c
        }
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('VatAmountToggler', {
    attrs: {
      "label": "Amount",
      "tax": _vm.body.tax
    },
    model: {
      value: (_vm.body.amount),
      callback: function($$v) {
        _vm.$set(_vm.body, "amount", $$v)
      },
      expression: "body.amount"
    }
  })], 1)])]), _c('div', {
    staticClass: "row columns",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c04ba112!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CommonCostButtonModal.vue
// module id = 2684
// module chunks = 1